import {
    Button,
    Card,
    CardContent,
    CardMedia,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from "@material-ui/core";
import React from "react";
import productItemStyle from "./productItemStyle";
import Box from "@material-ui/core/Box";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import NotFoundImg from "../../assets/not-found.png";

const useStyles = makeStyles((theme) => productItemStyle(theme));

const handleImageError = (event) => {
  event.target.src = NotFoundImg;
}

const ProductItem = ({ product, onEdit, deleteProduct }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
          <CardMedia
            component="img"
            onError={handleImageError}
            className={classes.cover}
            image={product.imagem}
            title={product.nome}
          />

          <CardContent className={classes.content}>
            <List
              component="nav"
              aria-label="main mailbox folders"
              className={classes.productList}
            >
              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Nome:"
                  secondary={product.nome}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Código:"
                  secondary={product.codigo}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Preço:"
                  secondary={`R$ ${product.preco}`}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Preço de Custo:"
                  secondary={`R$ ${product.preco_custo}`}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Segmentos:"
                  secondary={product.segmento?.join(', ')}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Estoque mínimo:"
                  secondary={product.estoque_minimo}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Estoque atual:"
                  secondary={product.estoque_atual}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Compatibilidade:"
                  secondary={product.compatibilidade?.join(', ')}
                  className={classes.listItem}
                />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Código fornecedor:"
                  secondary={product.codigo_fornecedor}
                  className={classes.listItem}
                />
              </ListItem>
              
              <ListItem className={classes.listItem}>
                <ListItemText
                  primary="Localização:"
                  secondary={product.localizacao}
                  className={classes.listItem}
                />
              </ListItem>
            </List>
          </CardContent>

          <Box className={classes.actions}>
            <Button
              className={`${classes.button} ${classes.redBtn}`}
              variant="contained"
              startIcon={<DeleteIcon />}
              onClick={() => deleteProduct(product.Id)}
            >
                Remover
            </Button>

            <Button
              className={`${classes.button} ${classes.yellowBtn}`}
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => onEdit(product)}
            >
                Editar
            </Button>
          </Box>
        </Card>
    );
};

export default ProductItem;
